import { Mutex } from "async-mutex";
import { appConfig } from "../../appConfig";

let refreshPromise: Promise<boolean> | null = null;
const mutex = new Mutex();

/**
 * Refresh Manager
 * - deduplicates refresh calls
 * - safe for CSR + SSR hydration mismatch
 */
class RefreshManager {
  /**
   * Main refresh entry
   * - ensures only ONE refresh in flight globally
   */
  async refresh(fetchFn: typeof fetch): Promise<boolean> {
    // If refresh already running → reuse it
    if (refreshPromise) return refreshPromise;

    refreshPromise = (async () => {
      const release = await mutex.acquire();

      try {
        const res = await fetchFn(appConfig.refreshUrl, {
          method: "POST",
          credentials: "include",
        });

        if (!res.ok) {
          return false;
        }

        return true;
      } catch {
        return false;
      } finally {
        release();
        refreshPromise = null;
      }
    })();

    return refreshPromise;
  }

  /**
   * Optional: force reset (useful on logout)
   */
  reset() {
    refreshPromise = null;
  }
}

export const refreshManager = new RefreshManager();
